module.exports = __webpack_public_path__ + "img/homea1.a9ad5302.jpg";